module.exports = __webpack_public_path__ + "angular/components/footer/ebFooter-6a32364f.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/footer/ebFooter.html
// module id = 53
// module chunks = 0